import {
  InvestmentType,
  EntityTypes,
  DurationType,
  DefaultProjectionYear,
} from "../helpers/constant";
import { CommonHelper } from "../helpers";
export default {
  getEmptyInvestmentModel(clientInfo) {
    let p = {};
    p.clientName = clientInfo.clientName;
    p.clientId = clientInfo.clientId;
    p.ownerId = clientInfo.clientId;
    p.ownerEntityType = clientInfo.entityType;
    p.amount = 0;
    p.projectionYear = DefaultProjectionYear;
    p.description = "New Investment";
    p.investmentClassID = InvestmentType.Investment_Platform;
    p.investmentId = 0;
    p.s3FilePath = "";
    p.incomeRate = 0;
    p.isExisting = false;
    p.frequencyId = 0;
    p.growthRate = 0;
    p.frankingRate = 0;
    p.isFromFact = false;
    p.contributionAmount = 0;
    p.riskProfileId = 0;
    p.investmentGuid = "00000000-0000-0000-0000-000000000000";
    p.startDate = new Date().toISOString().slice(0, 10);
    p.isRenewAuto = false;
    p.maturityDate = null;
    p.durationType = DurationType.Weeks;
    p.factAmount = 0;
    p.durationTypeId = DurationType.Weeks;
    p.isDRP = false;
    p.factInvestmentAmount = 0;
    p.advancedetails = [];

    return p;
  },

  setInvestmentInformation(payload, clientDetails) {
    let parentClientInfo = clientDetails.filter(
      (sr) => sr.entityType == EntityTypes.client
    );
    return payload.map((r) => {
      let p = {};

      let clientInfo = clientDetails.filter((item) => {
        return item.clientId == (r.ownerId == 0 ? r.clientId : r.ownerId);
      });
      p.clientName =
        clientInfo && clientInfo.length > 0 ? clientInfo[0].clientName : "";
      p.clientId =
        parentClientInfo && parentClientInfo.length > 0
          ? parentClientInfo[0].clientId
          : 0;
      p.ownerId = r.ownerId == 0 ? r.clientId : r.ownerId;
      p.ownerEntityType =
        clientInfo && clientInfo.length > 0 ? clientInfo[0].entityType : 0;
      p.platformId = r.platformid;
      p.s3FilePath = r.s3FilePath;
      p.isRenewAuto = r.isRenewAuto;
      p.maturityDate = r.maturityDate;
      p.description = r.description;
      p.investmentGuid = r.investmentGuid;
      p.parentInvestmentGuid = r.parentInvestmentGuid;
      p.amount = r.investmentAmount;
      p.incomeRate = r.incomeRate;
      p.frankingRate = r.frankedRate;
      p.contributionAmount = r.contributionAmount;
      p.riskProfileId = r.riskProfileId;
      p.isDRP = r.isDRP;
      p.frequencyId = r.frequencyId;
      p.factInvestmentAmount = r.factInvestmentAmount;
      p.durationTypeId =
        r.frequencyId == 0 ? DurationType.Months : r.frequencyId;
      p.projectionYear =
        r.projectionYear == 0 ? DefaultProjectionYear : r.projectionYear;
      p.growthRate = r.growthRate;
      p.feeAmount = r.feeAmount;
      p.investmentClassID = p.platformId > 0 ? "ITP" : r.investmentClassID;
      let actualDate = r.updatedDate
        ? r.updatedDate.slice(0, 10)
        : new Date().toISOString().slice(0, 10);
      let currentDate = new Date().toISOString().slice(0, 10);
      p.date =
        CommonHelper.formatDate(actualDate) ==
        CommonHelper.formatDate(currentDate)
          ? "Today"
          : CommonHelper.formatDate(actualDate);
      p.isExisting = r.isExisting;

      p.name = "Balance";
      p.advancedetails = !r.advancedetails ? [] : r.advancedetails;
      return p;
    });
  },

  setInvestmentEntiyInformation(clientInfo) {
    let entityInfo = clientInfo.map((r) => {
      if (
        r.entityType == EntityTypes.client ||
        r.entityType == EntityTypes.partner ||
        r.entityType == EntityTypes.both
      ) {
        let p = {};
        p.value = r.clientId;
        p.text = r.clientName.replace(/(^MRS|MR|MISS)/gi, "");
        p.dob = CommonHelper.formatDate(r.dob, false, "/");
        p.gender = r.gender;
        p.entityType = r.entityType;
        p.id = r.entityType == EntityTypes.both ? 2.1 : r.entityType;
        return p;
      }
    });
    let selectedUser = entityInfo.filter((sr) => sr != undefined);
    if (selectedUser && selectedUser.length > 0) {
      selectedUser = selectedUser.sort(function (a, b) {
        return a.id - b.id;
      });
    }
    return selectedUser;
  },
  setInvestmentTypeInformation() {
    let investmentType = [];
    investmentType.push({
      value: InvestmentType.Investment_Platform,
      text: "Investment Platforms",
    });
    investmentType.push({
      value: InvestmentType.Direct_Shares,
      text: "Australian Shares",
    });
    investmentType.push({
      value: InvestmentType.Direct_Managed_Funds,
      text: "Managed Fund",
    });
    investmentType.push({
      value: InvestmentType.BANK_Account,
      text: "Bank Deposit",
    });
    investmentType.push({
      value: InvestmentType.Term_Deposit,
      text: "Term Deposit",
    });
    investmentType.push({ value: InvestmentType.Others, text: "Others" });
    return investmentType;
  },
  CreateInvestmentModel(formModel, currentInvestmentInfo) {
    let totalElement = formModel.elements.length;
    let htmlName = "";
    for (let i = 0; i < totalElement; i++) {
      htmlName = formModel.elements[i].htmlName;
      if (htmlName == "initialbalance") {
        currentInvestmentInfo.amount = formModel.elements[i].value;
      } else if (htmlName == "incomeRate") {
        currentInvestmentInfo.incomeRate = formModel.elements[i].value;
      } else if (htmlName == "growthRate") {
        currentInvestmentInfo.growthRate = formModel.elements[i].value;
      } else if (htmlName == "frankingRate") {
        currentInvestmentInfo.frankingRate = formModel.elements[i].value;
      } else if (htmlName == "contributionAmount") {
        currentInvestmentInfo.contributionAmount = formModel.elements[i].value;
      } else if (htmlName == "DRP") {
        currentInvestmentInfo.isDRP = formModel.elements[i].value;
      } else if (htmlName == "riskProfile") {
        currentInvestmentInfo.riskProfileId = formModel.elements[i].value;
      } else if (htmlName == "durationType") {
        currentInvestmentInfo.durationTypeId = formModel.elements[i].value;
        currentInvestmentInfo.durationType =
          currentInvestmentInfo.durationTypeId == DurationType.Weeks
            ? "Weeks"
            : currentInvestmentInfo.durationTypeId == DurationType.Months
            ? "Months"
            : currentInvestmentInfo.durationTypeId == DurationType.Fortnights
            ? "Fortnights"
            : currentInvestmentInfo.durationTypeId == DurationType.Half_Year
            ? "Half Year"
            : currentInvestmentInfo.durationTypeId == DurationType.Years
            ? "Years"
            : "";
      }

      currentInvestmentInfo.ErrorText = [];
      currentInvestmentInfo.IsError = false;
    }
    return currentInvestmentInfo;
  },
};
